import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Accordion/sgds-accordion-item";
import { register } from "../../utils/ce-registry";

register("sgds-accordion-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-accordion-item",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
